<template>
  <div class="ibox float-e-margins">
    <account-header :account="account"></account-header>
    <account-content :account="account"></account-content>
  </div>
</template>
<script>
import axios from 'axios'
import Header from './Header.vue'
import Content from './Content.vue'

export default {
  data () {
    return {
      account: {}
    }
  },
  components: {
    accountHeader: Header,
    accountContent: Content
  },
  mounted () {
    this.loadAccount()
  },
  methods: {
    async loadAccount () {
      try {
        let r = await axios.get(`/v2/service-accounts/${this.$route.params.id}`)
        this.account = r.data
      } catch (error) {
        this.$toastr.error('Failed to load account credentials', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ServiceAccounts/SingleView/ServiceAccount.vue